import axios from 'axios'
import { corsairClientRequest } from './api'
import {
    BOT_ACTION_URL,
    CANVAS_API_URL,
    CHATS_HANDLER,
    EVENT_URL,
    MOBILE_API_URL,
    PROVISION_USER_URL,
    SCOOP_WEB_API_URL,
    SHEET_SERVER_URL,
    UI_INFORMATION_URL,
    WORKSHEET_ACTIONS_URL,
    WORKSPACE_ACTIONS_URL,
} from './apiEnum'

const basePost = async (url, data) => {
    return await corsairClientRequest({
        method: 'post',
        data: data,
        url: url,
    })
}

const baseGet = async (url) => {
    return await corsairClientRequest({
        method: 'get',
        url: url,
    })
}

const basePut = async (url, data) => {
    return await corsairClientRequest({
        method: 'put',
        data: data,
        url: url,
    })
}

const baseDelete = async (url) => {
    return await corsairClientRequest({
        method: 'delete',
        url: url,
    })
}

export const mobileApiRequest = async (data) => {
    return await basePost(MOBILE_API_URL, data)
}

export const uiInformationRequest = async (data) => {
    return await basePost(UI_INFORMATION_URL, data)
}

export const workspaceActionsRequest = async (data) => {
    return await basePost(WORKSPACE_ACTIONS_URL, data)
}

export const worksheetActionsRequest = async (data) => {
    return await basePost(WORKSHEET_ACTIONS_URL, data)
}

export const sheetServerRequest = async (data) => {
    return await basePost(SHEET_SERVER_URL, data)
}

export const canvasApiRequest = async (data) => {
    return await basePost(CANVAS_API_URL, data)
}

export const botActionRequest = async (data) => {
    return await basePost(BOT_ACTION_URL, data)
}

export const scoopWebApiRequest = async (data) => {
    return await basePost(SCOOP_WEB_API_URL, data)
}

export const eventRequest = async (data) => {
    return await basePost(EVENT_URL, data)
}

export const chatsPostRequest = async (data, optionalPath) => {
    return await basePost(CHATS_HANDLER + (optionalPath || ''), data)
}

export const chatsGetRequest = async (path) => {
    return await baseGet(CHATS_HANDLER + path)
}

export const chatsPutRequest = async (data, path) => {
    return await basePut(CHATS_HANDLER + path, data)
}

export const chatsDeleteRequest = async (path) => {
    return await baseDelete(CHATS_HANDLER + path)
}

/**
 * Pre-auth request for API calls before user is authenticated in Redux.
 * Used during login flows where token comes from Cognito directly.
 */
export const preAuthRequest = async (url, data, token) => {
    const response = await axios.post(
        `${process.env.REACT_APP_SCOOP_API}${url}`,
        {
            ...data,
            isDev: process.env.REACT_APP_SCOOP_ENV === 'dev',
        },
        {
            headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${token}`,
            },
        }
    )
    return response.data
}

/**
 * Pre-auth request without token for public endpoints.
 * Used for user provisioning during signup.
 */
export const preAuthRequestNoToken = async (url, data) => {
    const response = await axios.post(
        `${process.env.REACT_APP_SCOOP_API}${url}`,
        {
            ...data,
            isDev: process.env.REACT_APP_SCOOP_ENV === 'dev',
        },
        {
            headers: {
                'Content-Type': 'application/json',
            },
        }
    )
    return response
}

export const provisionUserRequest = async (data) => {
    return await preAuthRequestNoToken(PROVISION_USER_URL, data)
}
